<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <OverlayContent />
    <ClientOnly>
      <PChatContainer v-if="tickBu" />
    </ClientOnly>
    <div v-if="isInitializing" class="app-loading">
      <p-loading size="lg" color="fg-accent" />
    </div>
    <p-mobile-search-overlay v-model="isSearchOverlayVisible" />
    <p-global-notify />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useSearchOverlay } from '~/composables/useSearchOverlay'
import { useUserStore } from '@/store/user'
import PGlobalNotify from '@/components/ui/PGlobalNotify/PGlobalNotify.vue'

const { isSearchOverlayVisible } = useSearchOverlay()
const userStore = useUserStore()
const { isInitializing } = storeToRefs(userStore)

const tickBu = useRuntimeConfig().public.tickBu === 'true'

const route = useRoute()
const router = useRouter()
const requestUrl = useRequestURL()
// router.resolve(...).href prepends the app baseURL (`/destek/`) so the
// canonical reflects the public URL the user actually visits, not the
// app-internal route path.
const canonicalHref = computed(
  () => `${requestUrl.origin}${router.resolve({ path: route.path }).href}`,
)
useHead({
  link: [{ rel: 'canonical', href: canonicalHref, key: 'canonical' }],
})

onMounted(() => {
  userStore.initializeClientAuth()
})
</script>

<style lang="scss" scoped>
.app-loading {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-white, #fff);
  z-index: 9999;
}
</style>
